export const ENQUETE_THREAD_PATH = {
  INDEX: '/general/enquete-threads',
  CREATE: '/general/enquete-threads',
  DETAIL: (id: string) => `/general/enquete-threads/detail/${id}`,
  EDIT: (id: string) => `/general/enquete-threads/edit/${id}`,
};
